module.exports = __webpack_public_path__ + "assets/d85b6054f7e0e18049beb1935bd3f8a1.png";